import Button from '@betterfunnel/ui-core/Button';
import { PlusIcon } from '@heroicons/react/24/solid';

export default function SocialCampaigns() {
  return (
    <>
      <div className="flex h-full w-full flex-col">
        <div className="flex flex-col gap-4 bg-white">
          <div className="flex flex-col items-stretch sm:flex-row sm:items-center">
            <div className="flex h-12 w-full flex-row items-center justify-between gap-2 border-b border-gray-300 pb-3">
              <h1 className="w-full grow text-2xl font-semibold leading-6 text-gray-900">
                Social Campaigns
              </h1>
              <div className="flex flex-row gap-2">
                <Button
                  disabled
                  className="shrink-0 whitespace-nowrap"
                  onClick={() => {}}
                  icon={<PlusIcon className="h-4 w-4" />}
                >
                  New Ad Account
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-80 text-center">
          <p className="text-base font-semibold text-indigo-600">
            BetterFunnel is expanding...
          </p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Social Campaigns are coming soon!
          </h1>
        </div>
      </div>
      {/* <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-indigo-600">
            BetterFunnel is expanding...
          </p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Social Campaigns are coming soon!
          </h1>
        </div>
      </main> */}
    </>
  );
}
